export const interpolate = (str, props) => {
  Object.entries(props || {}).forEach(([key, value]) => {
    str = str.replace(new RegExp(`\\{{2}\\s*${key}\\s*\\}{2}`, "g"), value || "");
  });
  return str;
};